Routes.$inject = [
    '$stateProvider',
    '$urlRouterProvider',
    'routerResolverProvider',
    'disabled_features',
];

/* @ngInject */
function Routes(
    $stateProvider,
    $urlRouterProvider,
    routerResolverProvider,
    disabled_features,
) {
    // APPLICATION ROUTES
    // -----------------------------------
    // For any unmatched url, redirect to /app/grid
    $urlRouterProvider.otherwise(function ($injector, $location) {
        const CONST = $injector.get('CONST');
        const User = $injector.get('User');

        if (!User.loggedIn) {
            return $location.path('/login/signin');
        }

        if (CONST._loaded) {
            const Club = $injector.get('Club');
            const hasFeatureEnabled = Club.hasNewBookingsCalendarEnabled();
            return hasFeatureEnabled
                ? $location.path('/app/grid')
                : $location.path('/app/bookings');
        } else {
            CONST.$info()
                .then(function () {
                    const Club = $injector.get('Club');
                    const hasFeatureEnabled =
                        Club.hasNewBookingsCalendarEnabled();
                    return hasFeatureEnabled
                        ? $location.path('/app/grid')
                        : $location.path('/app/bookings');
                })
                .catch(function () {
                    return $location.path('/login/signin');
                });
        }
    });
    //
    // Set up the states
    $stateProvider
        .state('app', {
            url: '/app',
            abstract: true,
            title: 'AlquilaTuCancha',
            template: require('../../views/app.html'),
            resolve: routerResolverProvider.firstLoad('app'),
        })
        /**
         * DASHBOARD
         */
        .state('app.dashboard', {
            url: '/dashboard',
            title: 'Tablero',
            template: require('../../views/dashboard.html'),
            ncyBreadcrumb: {
                label: 'Tablero',
            },
        })
        /**
         * BOOKINGS
         */
        /**
         * START
         * Landing used by the hand-off page (/club/{club}/ingreso): once the
         * session and tokens are in place it sends the user where the classic
         * login would, once the app resolver has loaded the club and the user.
         */
        .state('app.start', {
            url: '/start',
            title: 'Ingresando',
            template: '<p class="text-center" style="margin-top: 80px">Ingresando…</p>',
            controller: [
                '$state',
                'Club',
                function ($state, Club) {
                    $state.go(
                        Club.hasNewBookingsCalendarEnabled()
                            ? 'app.grid'
                            : 'app.bookings',
                    );
                },
            ],
        })
        .state('app.bookings', {
            url: '/bookings',
            title: 'Reservas',
            template: require('../../views/booking/landing.html'),
            ncyBreadcrumb: {
                label: 'Reservas',
            },
        })
        .state('app.bookings-legacy-d3bug-0g', {
            url: '/bookings-legacy-d3bug-0g',
            title: 'Reservas Legacy',
            template: require('../../views/booking/landing.html'),
            ncyBreadcrumb: {
                label: 'Reservas Legacy',
            },
        })
        /**
         * Nueva Grilla
         */
        .state('app.grid', {
            url: '/grid?date',
            reloadOnSearch: false,
            title: 'Tablero',
            template: `<div ng-controller="BookingsController as vm">
                    <div backoffice-dashboard></div>
                </div>`,
            ncyBreadcrumb: {
                label: 'Tablero',
            },
        })
        .state('app.bookings-new-d3bug-0g', {
            url: '/bookings-new-d3bug-0g?date',
            reloadOnSearch: false,
            title: 'Tablero Legacy',
            template: `<div ng-controller="BookingsController as vm">
                    <div backoffice-dashboard is-debug-mode="true"></div>
                </div>`,
            ncyBreadcrumb: {
                label: 'Tablero Legacy',
            },
        })
        .state('app.sportclub-wpp-integration', {
            url: '/sportclub-wpp-integration',
            title: 'Sportclub WPP Integration',
            template: `<div sportclub-wpp-integration style="background-color: white; margin-inline: -15px;"></div>`,
            ncyBreadcrumb: {
                label: 'Sportclub WPP Integration',
            },
        })
        .state('app.cash-register-reconciliation', {
            url: '/cash-register-reconciliation',
            title: 'Arqueo de caja',
            template:
                '<div cash-register-reconciliation style="background-color: white; margin-inline: -15px;"></div>',
            ncyBreadcrumb: {
                label: 'Arqueo de caja',
            },
        })
        /**
         * CLUB ROUTES
         */
        .state('app.club', {
            url: '/club',
            abstract: true,
            title: 'Club',
            template: '<div ui-view class="fade-in-up"></div>',
            ncyBreadcrumb: {
                label: 'Club',
            },
        })
        .state('app.club.profile', {
            url: '/profile',
            template: require('../../views/club/profile.html'),
            title: 'Club - Info',
            ncyBreadcrumb: {
                label: 'Info',
            },
            role: [2, 4],
        })
        .state('app.club.courts', {
            url: '/courts',
            template: require('../../views/club/courts.html'),
            title: 'Club - Canchas',
            ncyBreadcrumb: {
                label: 'Canchas',
            },
            role: [2, 4],
        })
        .state('app.club.turn-types', {
            url: '/turn-types',
            title: 'Club - Tipos de turno',
            template:
                '<div turn-types style="background-color: white; margin-inline: -15px;"></div>',
            ncyBreadcrumb: {
                label: 'Tipos de turno',
            },
            role: [2, 4],
        })
        .state('app.club.users', {
            url: '/users',
            template: require('../../views/club/users.html'),
            title: 'Club - Usuarios',
            ncyBreadcrumb: {
                label: 'Usuarios',
            },
            role: [2, 4],
        })
        .state('app.club.calendar', {
            url: '/calendar',
            template: require('../../views/club/calendar.html'),
            title: 'Club - Calendario',
            ncyBreadcrumb: {
                label: 'Calendario',
            },
            role: [2, 4],
        })
        .state('app.club.mp-vinculation', {
            url: '/mp-vinculation',
            template: require('../../views/club/old.mp.connection.html'),
            title: 'Club - Info',
            ncyBreadcrumb: {
                label: 'Info',
            },
            role: [2, 4],
        })
        /**
         * USER ROUTES
         */
        .state('app.account', {
            url: '/account',
            abstract: true,
            template: '<div ui-view class="fade-in-up"></div>',
            title: 'Mi cuenta',
            ncyBreadcrumb: {
                label: 'Mi cuenta',
            },
        })
        .state('app.account.personal', {
            url: '/personal',
            template: require('../../views/account/personal.html'),
            title: 'Mi cuenta - Datos personales',
            ncyBreadcrumb: {
                label: 'Datos personales',
            },
        })
        .state('app.account.notifications', {
            url: '/notifications',
            template: require('../../views/account/notifications.html'),
            title: 'Mi cuenta - Notificaciones',
            ncyBreadcrumb: {
                label: 'Configurar notificaciones',
            },
        })
        .state('app.account.password', {
            url: '/password',
            template: require('../../views/account/password.html'),
            title: 'Mi cuenta - Cambio de claves',
            ncyBreadcrumb: {
                label: 'Cambio de claves',
            },
        })
        /**
         * REPORTS ROUTES
         */
        .state('app.reports', {
            url: '/reports',
            abstract: true,
            template: require('../../views/report/landing.html'),
            // ncyBreadcrumb: {
            //     label: 'Reportes',
            // },
        })
        .state('app.reports.dashboard', {
            url: '/dashboard',
            template: require('../../views/report/dashboard.html'),
            title: 'Reportes - Resumen',
            ncyBreadcrumb: {
                label: 'Resumen general',
            },
        })
        .state('app.reports.daily', {
            url: '/daily/:date',
            parent: 'app.reports',
            template: require('../../views/report/daily.html'),
            title: 'Reportes - Informe diario',
            ncyBreadcrumb: {
                label: 'Diario',
            },
        })
        .state('app.reports.cash', {
            url: '/cash',
            template: `<div cash-reports style="background-color: white; margin-inline: -15px;"></div>`,
            title: 'Caja - Resumen de Caja',
            ncyBreadcrumb: {
                label: 'Resumen de Caja',
            },
        })
        .state('app.reports.sales-purchases', {
            url: '/sales-purchases',
            template: `<div sales-purchases style="background-color: white; margin-inline: -15px;"></div>`,
            title: 'Ventas y Compras',
            ncyBreadcrumb: {
                label: 'Ventas y Compras',
            },
        })
        .state('app.metrics', {
            url: '/metrics',
            abstract: true,
            template: require('../../views/report/landing.html'),
        })
        .state('app.metrics.bookings', {
            url: '/bookings',
            template:
                '<div metrics-bookings style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Reservas',
            ncyBreadcrumb: {
                label: 'Reservas',
            },
        })
        .state('app.metrics.cancellations', {
            url: '/cancellations',
            template:
                '<div metrics-cancellations style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Cancelaciones',
            ncyBreadcrumb: {
                label: 'Cancelaciones',
            },
        })
        .state('app.metrics.players', {
            url: '/players',
            template:
                '<div metrics-players style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Jugadores',
            ncyBreadcrumb: {
                label: 'Jugadores',
            },
        })
        .state('app.metrics.teachers-and-tournaments', {
            url: '/teachers-and-tournaments',
            template:
                '<div metrics-teachers-and-tournaments style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Profesores, escuelitas y torneos',
            ncyBreadcrumb: {
                label: 'Profesores, escuelitas y torneos',
            },
        })
        .state('app.metrics.stock', {
            url: '/stock',
            template:
                '<div metrics-stock style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Stock',
            ncyBreadcrumb: {
                label: 'Stock',
            },
        })
        .state('app.metrics.receipts', {
            url: '/receipts',
            template:
                '<div metrics-receipts style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Cobros',
            ncyBreadcrumb: {
                label: 'Cobros',
            },
        })
        .state('app.metrics.control', {
            url: '/control',
            template:
                '<div metrics-control style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Control',
            ncyBreadcrumb: {
                label: 'Control',
            },
        })
        .state('app.metrics.buffet', {
            url: '/buffet',
            template:
                '<div metrics-buffet style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Métricas - Mesas y cuentas',
            ncyBreadcrumb: {
                label: 'Mesas y cuentas',
            },
        })
        /**
         * PLAYERS
         */
        .state('app.players', {
            url: '/players',
            abstract: true,
            template: '<div ui-view></div>',
            ncyBreadcrumb: {
                label: 'Jugadores',
            },
        })
        .state('app.players.list', {
            url: '',
            template:
                '<div players-v3-list style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Jugadores - Listado',
            ncyBreadcrumb: {
                label: 'Listado',
            },
        })
        /**
         * STOCK
         */
        .state('app.stock', {
            url: '/stock',
            abstract: true,
            template: '<div ui-view></div>',
            ncyBreadcrumb: {
                label: 'Stock',
            },
        })
        .state('app.stock.items', {
            url: '/items',
            template:
                '<div list-stock-items style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Stock - Listado de Artículos',
            ncyBreadcrumb: {
                label: 'Listado de Artículos',
            },
        })
        .state('app.reports.stock', {
            url: '/info',
            template:
                '<div stock-info style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Stock - Información del Stock',
            ncyBreadcrumb: {
                label: 'Información del Stock',
            },
        })

        .state('app.payments', {
            url: '/payments',
            template:
                '<div ng-if="onlyShowOnArgentina()" payments-section style="background-color: white; margin-inline: -15px;"></div>',
            title: 'Pagos- Sección Pagos',
            ncyBreadcrumb: {
                label: 'Sección Pagos',
            },
        })
        /**
         * ABOUT
         */
        .state('app.changelog', {
            url: '/changelog',
            template: require('../../views/changelog.html'),
            title: 'Novedades',
            ncyBreadcrumb: {
                label: 'Novedades',
            },
        })
        /**
         * HELP
         */
        .state('app.help', {
            url: '/help',
            abstract: true,
            template: '<div ui-view class="fade-in-up"></div>',
            title: 'Centro de Ayuda',
            ncyBreadcrumb: {
                label: 'Ayuda',
            },
        })
        .state('app.help.index', {
            url: '/index',
            template: 'Centro de Ayuda',
            title: 'Centro de Ayuda',
            ncyBreadcrumb: {
                label: 'Ayuda',
            },
        })
        .state('app.help.tip', {
            url: '/tip/:id',
            template: 'TIP',
            title: 'Centro de Ayuda',
            ncyBreadcrumb: {
                label: 'Tip',
            },
        })
        /*
         * LOGIN ROUTES
         */
        .state('login', {
            url: '/login',
            abstract: true,
            template: '<div ui-view class="fade-in-right-big smooth"></div>',
            resolve: routerResolverProvider.firstLoad('login'),
        })
        .state('login.signin', {
            url: '/signin',
            title: 'Ingresar',
            template: require('../../views/login/login.html'),
        })
        .state('login.forgot', {
            url: '/forgot',
            title: 'Recordar contraseña',
            template: require('../../views/login/forgot.html'),
        })
        .state('login.lockscreen', {
            url: '/lock',
            template: require('../../views/login/lock_screen.html'),
        });

    if (!disabled_features.includes('matches')) {
        $stateProvider.state('app.matches', {
            url: '/matches',
            template: `<div matches-info style="background-color: white; margin-inline: -15px;"></div>`,
            title: 'Partidos',
            ncyBreadcrumb: {
                label: 'Partidos',
            },
        });
    }
}

export default Routes;
